/**
 * PaymentAPIHook.tsx
 *
 * Adds an Axios hook that redirects payment responses made to Express API.
 *
 */

import axios from "axios";

const PaymentAPIHook = ({ children }: { children: JSX.Element }) => {
  // Response interceptor for API calls
  axios.interceptors.response.use(
    (response) => {
      if (response.data?.userPaymentRequired) {
        window.location.href = "/payment-plan";
      }

      // Note: `access: false` (e.g. from the dashboard endpoint) is
      // intentionally NOT handled here. Silently hard-navigating away on
      // any `access: false` response hides the real reason from the user
      // and from whichever component made the request. Components that
      // can receive `access: false` should check for it themselves and
      // render an explicit message (see Dashboard.tsx).

      return Promise.resolve(response);
    },
    (error) => Promise.reject(error),
  );

  return children;
};

export default PaymentAPIHook;
